import { supabase, isSupabaseConfigured } from './supabaseClient';

function assertSupabase() {
  if (!isSupabaseConfigured || !supabase) {
    throw new Error('Supabase is not configured yet. Add your project URL and anon key first.');
  }
}

export async function signUp(email, password, fullName) {
  assertSupabase();

  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: {
        full_name: fullName,
      },
    },
  });

  if (error) {
    throw error;
  }

  if (Array.isArray(data.user?.identities) && data.user.identities.length === 0) {
    throw new Error('EMAIL_ALREADY_EXISTS');
  }

  return data.user;
}

export async function logIn(email, password) {
  assertSupabase();

  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  if (error) {
    throw error;
  }

  return data.user;
}

export async function signInWithGoogle() {
  assertSupabase();

  const { error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
  });

  if (error) {
    throw error;
  }
}

export async function signOutUser() {
  assertSupabase();

  const { error } = await supabase.auth.signOut();

  if (error) {
    throw error;
  }
}
